import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { tasksId } from '../../../types/activityTasks';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { PanelInstrucionHands } from '../../../components/common/PanelInstrucionHands';
import { team3_sub1_act_1_01 } from '../../../assets/imgIntruction/tema3';
import { ModalInfoPromotionV2 } from '../../../components/common/ModalInfoPromotionV2';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { voicesTypeControl } from '../../../types/audioType';
import { imagesTheme3 } from '../../../assets/tema3';
import { ButtonReturn } from '../../../components/common/ButtonReturn';


const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	panelInstruction: 3,
	panelExhibicion: 4,
	panelClock: 5,
	panelClean: 6,
	panelTemperature: 7,
	win: 8
};

const stepThree = {
	cubepaso1: steps.panelExhibicion,
	Circle: steps.panelClock,
	cubepaso2: steps.panelClean,
	esferapaso3: steps.panelTemperature,
};


export const Theme3SubtopicTwoActivityTwo = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema2], 2);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 2 act 2");
			ObserverEmitter.emit(EVENTS.tema3.topic2.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act2_a01T3)
	})

	ObserverEmitter.on(EVENTS.tema3.topic2.actTwo.clickRayCaster, (step = "") => {
		const stepSelect = stepThree[step]
		if (!stepSelect) {
			return
		}
		setUiToShow(stepSelect)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.initScene, 2);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 2: Warmer: Más información" />
					<DialogBarNew
						dialog={`¡Excelente trabajo! ahora, haz clic en las áreas resaltadas para obtener más información.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actTwo.moveWanner, "move_wanner")
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquina Warmer y Koxka y Salchikoxka"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							// ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.introduccion.intro01T2)
							setUiToShow(steps.panelInstruction);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{[-2].includes(uiToShow) && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.panelInstruction && (
				<>
					<PanelInstrucionHands
						text="Explora tocando las áreas iluminadas."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic2.actTwo.activyObj, "all_warner")
							setUiToShow(-2);
						}}
						img={team3_sub1_act_1_01}
					/>
				</>
			)}

			{uiToShow === steps.panelExhibicion && (
				<>
					<ModalInfoPromotionV2
						title={"Exhibición"}
						description={
							`La exhibición mínima en esta estación es de 2 productos por parrilla. `
						}
						url={imagesTheme3.topic1.Warmer01}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic2.actTwo.activyObj, "clock")
							setUiToShow(-1);
						}}
					></ModalInfoPromotionV2>
				</>
			)}
			{uiToShow === steps.panelClock && (
				<>
					<ModalInfoPromotionV2
						title={"Horario"}
						description={
							`A partir de las 7:00 a.m. verifica que la máquina esté encendida.  `
						}
						url={imagesTheme3.topic1.reloj01}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic2.actTwo.activyObj, "clean")
							setUiToShow(-1);
						}}
					></ModalInfoPromotionV2>
				</>
			)}
			{uiToShow === steps.panelClean && (
				<>
					<ModalInfoPromotionV2
						title={"Limpieza"}
						description={
							`Limpia la máquina con sanitizante, papel secante y el trapo azul.`
						}
						url={imagesTheme3.topic1.Limpieza01}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic2.actTwo.activyObj, "temperatura")
							setUiToShow(-1);
						}}
					></ModalInfoPromotionV2>
				</>
			)}
			{uiToShow === steps.panelTemperature && (
				<>
					<ModalInfoPromotionV2
						title={"Temperatura"}
						description={
							`La temperatura de la exhibición del warmer debe ser de entre 60 y 65 grados. `
						}
						url={imagesTheme3.topic1.Temperatura01}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic2.actTwo.activyObj)
							setUiToShow(steps.win);
						}}
					></ModalInfoPromotionV2>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Seguir los pasos para la correcta exhibición del warmer, es de suma para nuestros clientes."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 0,
									subtema: tasksId.tema3.activities.subtema2
								})
							);
							navigator("/home3/tema3/subtema2/activityThree");
						}}
					/>
				</>
			)}

		</>
	)
}
